module.exports = __webpack_public_path__ + "components/weather-icon/static/nightlightrain-ff48c740dac74cd226ff929f0577289f.svg";